/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import { textMarginSmall } from "../styles/base/textHelpers";
import { offerStrip } from "../styles/modules/offerStrip";
const OfferStrip = ({ children, modifierCSS }) => (<section css={css([textMarginSmall(), offerStrip, ...modifierCSS])}>
		{children}
	</section>);
export default OfferStrip;
